module.exports = __webpack_public_path__ + "static/media/eukaryotes_gene_lists.6418f344.png";